import { blurLinear } from './blur/blurLinear'
import { blurPixelizeVar } from './blur/blurPixelizeVar'
import { blurZoomVar } from './blur/blurZoomVar'
import { radialBlurVar } from './blur/radialBlur'
import { starBlurVar } from './blur/starBlur'
import { cropBoxVar } from './crop/cropBoxVar'
import { cropCrossVar } from './crop/cropCrossVar'
import { cropPolygonVar } from './crop/cropPolygonVar'
import { cropRhombusVar } from './crop/cropRhombusVar'
import { cropStarsVar } from './crop/cropStarsVar'
import { cropTriangleVar } from './crop/cropTriangleVar'
import { cutApollonianVar } from './cut/cutApollonianVar'
import { cutCircleDesignVar } from './cut/cutCircleDesignVar'
import { cutFractalVar } from './cut/cutFractalVar'
import { pixelFlowVar } from './dc/pixelFlowVar'
import { anamorphCylVar } from './general/anamorphCylVar'
import { asteriaVar } from './general/asteriaVar'
import { atan2SpiralsVar } from './general/atan2SpiralsVar'
import { atanVar } from './general/atanVar'
import { augerVar } from './general/augerVar'
import { barycentroidVar } from './general/barycentroidVar'
import { bcollideVar } from './general/bcollideVar'
import { bent2Var } from './general/bent2Var'
import { bipolar2Var } from './general/bipolar2Var'
import { bipolarVar } from './general/bipolarVar'
import { blob } from './general/blob'
import { blockYVar } from './general/blockYVar'
import { bmodVar } from './general/bmodVar'
import { boarders2Var } from './general/boarders2Var'
import { boxfoldVar } from './general/boxfoldVar'
import { bsplitVar } from './general/bsplitVar'
import { bswirlVar } from './general/bswirlVar'
import { bTransformVar } from './general/bTransformVar'
import { bubble2Var } from './general/bubble2Var'
import { bulgeVar } from './general/bulgeVar'
import { butterflyFayVar } from './general/butterflyFayVar'
import { bwrandsVar } from './general/bwrandsVar'
import { bwraps7Var } from './general/bwraps7Var'
import { camouflageVar } from './general/camouflageVar'
import { cannabisCurveVar } from './general/cannabisCurveVar'
import { cardioidVar } from './general/cardioidVar'
import { cell2Var } from './general/cell2Var'
import { cellVar } from './general/cellVar'
import { chaosCubesVar } from './general/chaosCubesVar'
import { checksVar } from './general/checksVar'
import { chunkVar } from './general/chunkVar'
import { circleLinearVar } from './general/circleLinearVar'
import { circleRandVar } from './general/circleRandVar'
import { circlesplitVar } from './general/circlesplitVar'
import { circlize2Var } from './general/circlize2Var'
import { circlizeVar } from './general/circlizeVar'
import { circular2Var } from './general/circular2Var'
import { circularVar } from './general/circularVar'
import { circus } from './general/circus'
import { cliffordVar } from './general/cliffordVar'
import { collideoscopeVar } from './general/collideoscopeVar'
import { coneVar } from './general/coneVar'
import { conicVar } from './general/conicVar'
import { cornersVar } from './general/cornersVar'
import { cos2_bsVar } from './general/cos2_bsVar'
import { cosh2_bsVar } from './general/cosh2_bsVar'
import { cot2_bsVar } from './general/cot2_bsVar'
import { coth2_bsVar } from './general/coth2_bsVar'
import { cpow2Var } from './general/cpow2Var'
import { cpowVar } from './general/cpowVar'
import { crobVar } from './general/crobVar'
import { csc2_bsVar } from './general/csc2_bsVar'
import { csch2_bsVar } from './general/csch2_bsVar'
import { cscSquaredVar } from './general/cscSquaredVar'
import { csinVar } from './general/csinVar'
import { curlVar } from './general/curl'
import { curveVar } from './general/curveVar'
import { devilWarpVar } from './general/devilWarpVar'
import { disc2Var } from './general/disc2Var'
import { disc3Var } from './general/disc3Var'
import { dragonVar } from './general/dragonVar'
import { dSphericalVar } from './general/dSphericalVar'
import { eclipseVar } from './general/eclipseVar'
import { ejuliaVar } from './general/ejuliaVar'
import { elliptic2Var } from './general/elliptic2Var'
import { ellipticVar } from './general/ellipticVar'
import { eModVar } from './general/eModVar'
import { eMotionVar } from './general/eMotionVar'
import { epispiralVar } from './general/epispiralVar'
import { ePushVar } from './general/ePushVar'
import { eRotateVar } from './general/eRotateVar'
import { eScaleVar } from './general/eScaleVar'
import { escherVar } from './general/escherVar'
import { eSwirlVar } from './general/eSwirlVar'
import { exp2_bsVar } from './general/exp2_bsVar'
import { fan2 } from './general/fan2'
import { fdiscVar } from './general/fdiscVar'
import { fibonacci2Var } from './general/fibonacci2Var'
import { floraVar } from './general/floraVar'
import { flowerVar } from './general/flowerVar'
import { fluxVar } from './general/fluxVar'
import { fourthVar } from './general/fourthVar'
import { fresnelVar } from './general/fresnelVar'
import { funnelVar } from './general/funnelVar'
import { gingerBreadVar } from './general/gingerBreadVar'
import { glynnSim1Var } from './general/glynnSim1Var'
import { glynnSim2Var } from './general/glynnSim2Var'
import { glynnSim3Var } from './general/glynnSim3Var'
import { gosperVar } from './general/gosperVar'
import { grid } from './general/grid'
import { gridout2Var } from './general/gridout2Var'
import { gumowskiMiraVar } from './general/gumowskiMiraVar'
import { harmonographVar } from './general/harmonographVar'
import { henonVar } from './general/henonVar'
import { hexesVar } from './general/hexesVar'
import { hexModulusVar } from './general/hexModulusVar'
import { hilbertVar } from './general/hilbertVar'
import { hole2Var } from './general/hole2Var'
import { holeVar } from './general/holeVar'
import { hopalongVar } from './general/hopalongVar'
import { hyperbolicEllipseVar } from './general/hyperbolicEllipseVar'
import { hypershiftVar } from './general/hypershiftVar'
import { hypertile2Var } from './general/hypertile2Var'
import { hypertileVar } from './general/hypertileVar'
import { iconAttractorVar } from './general/iconAttractorVar'
import { intersectionVar } from './general/intersectionVar'
import { invCircle } from './general/invCircle'
import { invCircle2 } from './general/invCircle2'
import { invEllipse } from './general/invEllipse'
import { inversionVar } from './general/inversionVar'
import { joukowskiVar } from './general/joukowskiVar'
import { juliaCVar } from './general/juliaCVar'
import { juliaNVar } from './general/juliaNVar'
import { juliaOutsideVar } from './general/juliaOutsideVar'
import { juliaQVar } from './general/juliaQVar'
import { juliaScope } from './general/juliaScope'
import { kaleidoscopeVar } from './general/kaleidoscopeVar'
import { kaplanVar } from './general/kaplanVar'
import { kochVar } from './general/kochVar'
import { layeredSpiralVar } from './general/layeredSpiralVar'
import { lazySensenVar } from './general/lazySensenVar'
import { lazySusanVar } from './general/lazySusanVar'
import { linearTVar } from './general/linearTVar'
import { lineVar } from './general/lineVar'
import { lissajousVar } from './general/lissajousVar'
import { logApoVar } from './general/logApoVar'
import { logTile2Var } from './general/logTile2Var'
import { loonie2Var } from './general/loonie2Var'
import { loqVar } from './general/loqVar'
import { loziVar } from './general/loziVar'
import { macMillanVar } from './general/macMillanVar'
import { maskVar } from './general/maskVar'
import { maurerRoseVar } from './general/maurerRoseVar'
import { mobiusVar } from './general/mobiusVar'
import { modulusVar } from './general/modulusVar'
import { murl2Var } from './general/murl2Var'
import { murlVar } from './general/murlVar'
import { ngonVar } from './general/ngon'
import { nPolarVar } from './general/nPolarVar'
import { octagonVar } from './general/octagonVar'
import { onion2Var } from './general/onion2Var'
import { onionVar } from './general/onionVar'
import { oscilloscope2Var } from './general/oscilloscope2Var'
import { oscilloscopeVar } from './general/oscilloscopeVar'
import { ovoidVar } from './general/ovoidVar'
import { parabolaVar } from './general/parabolaVar'
import { pdjVar } from './general/pdj'
import { perlinNoiseVar } from './general/perlinNoise'
import { perspective } from './general/perspective'
import { phoenixJuliaVar } from './general/phoenixJuliaVar'
import { pieVar } from './general/pieVar'
import { plusRecipVar } from './general/plusRecipVar'
import { popcorn2Var } from './general/popcorn2Var'
import { powBlockVar } from './general/powBlockVar'
import { pressureWaveVar } from './general/pressureWaveVar'
import { projectiveVar } from './general/projectiveVar'
import { pTransformVar } from './general/pTransformVar'
import { pulseVar } from './general/pulseVar'
import { q_odeVar } from './general/q_odeVar'
import { rational3Var } from './general/rational3Var'
import { rectanglesVar } from './general/rectangles'
import { rings2 } from './general/rings2'
import { rippleVar } from './general/rippleVar'
import { roseVar } from './general/roseVar'
import { rsquaresVar } from './general/rsquaresVar'
import { sattractorVar } from './general/sattractorVar'
import { scry2Var } from './general/scry2'
import { seaShellVar } from './general/seaShellVar'
import { separationVar } from './general/separationVar'
import { shiftVar } from './general/shiftVar'
import { shreddedVar } from './general/shreddedVar'
import { shredlinVar } from './general/shredlinVar'
import { shredradVar } from './general/shredradVar'
import { sierCarpetVar } from './general/sierCarpetVar'
import { sigmoidVar } from './general/sigmoidVar'
import { sineBlurVar } from './general/sineBlurVar'
import { sintrangeVar } from './general/sintrangeVar'
import { sinusGridVar } from './general/sinusGridVar'
import { sphericalNVar } from './general/sphericalNVar'
import { spirographVar } from './general/spirographVar'
import { spligonVar } from './general/spligonVar'
import { splipticBSVar } from './general/splipticBSVar'
import { splitBrdrVar } from './general/splitBrdrVar'
import { splitsVar } from './general/splitsVar'
import { splitVar } from './general/splitVar'
import { squircularVar } from './general/squircularVar'
import { squirrelVar } from './general/squirrelVar'
import { squishVar } from './general/squishVar'
import { stripesVar } from './general/stripesVar'
import { stripfitVar } from './general/stripfitVar'
import { sTwinVar } from './general/sTwinVar'
import { sunflowerVar } from './general/sunflowerVar'
import { superShapeVar } from './general/superShapeVar'
import { svenssonVar } from './general/svenssonVar'
import { swirl3Var } from './general/swirl3Var'
import { targetVar } from './general/targetVar'
import { taurusVar } from './general/taurusVar'
import { tileHlpVar } from './general/tileHlpVar'
import { tradeVar } from './general/tradeVar'
import { treeVar } from './general/treeVar'
import { triangleVar } from './general/triangleVar'
import { truchet2Var } from './general/truchet2Var'
import { tunnelVar } from './general/tunnelVar'
import { vogelVar } from './general/vogelVar'
import { waffleVar } from './general/waffleVar'
import { wallPaperVar } from './general/wallPaperVar'
import { waves2Var } from './general/waves2Var'
import { waves3Var } from './general/waves3Var'
import { waves4Var } from './general/waves4Var'
import { wedgeJuliaVar } from './general/wedgeJuliaVar'
import { wedgeSphVar } from './general/wedgeSphVar'
import { wedgeVar } from './general/wedgeVar'
import { whorlVar } from './general/whorlVar'
import { woggleVar } from './general/woggleVar'
import { xheartVar } from './general/xheartVar'
import { yinYangVar } from './general/yinYangVar'
import { postAxisSymmetryWf } from './post/postAxisSymmetryWf'
import { postBWraps2 } from './post/postBWraps2'
import { postCircleCrop } from './post/postCircleCrop'
import { postCrop } from './post/postCrop'
import { postCurl } from './post/postCurl'
import { postHeatVar } from './post/postHeatVar'
import { postMirrorWf } from './post/postMirrorWf'
import { postPointSymmetryWf } from './post/postPointSymmetryWf'
import { symBandG1 } from './post/symBandG1'
import { symBandG2 } from './post/symBandG2'
import { symBandG3 } from './post/symBandG3'
import { symBandG4 } from './post/symBandG4'
import { symBandG5 } from './post/symBandG5'
import { symBandG6 } from './post/symBandG6'
import { symBandG7 } from './post/symBandG7'
import { symNetG1 } from './post/symNetG1'
import { symNetG2 } from './post/symNetG2'
import { symNetG3 } from './post/symNetG3'
import { symNetG4 } from './post/symNetG4'
import { symNetG5 } from './post/symNetG5'
import { symNetG6 } from './post/symNetG6'
import { symNetG7 } from './post/symNetG7'
import { symNetG8 } from './post/symNetG8'
import { symNetG9 } from './post/symNetG9'
import { symNetG10 } from './post/symNetG10'
import { symNetG11 } from './post/symNetG11'
import { symNetG12 } from './post/symNetG12'
import { symNetG13 } from './post/symNetG13'
import { symNetG14 } from './post/symNetG14'
import { symNetG15 } from './post/symNetG15'
import { symNetG16 } from './post/symNetG16'
import { symNetG17 } from './post/symNetG17'
import { preCurlVar } from './pre/preCurlVar'
import { preGaussianVar } from './pre/preGaussianVar'
import { synthVar } from './synthVar'

export const parametricVariations = {
  blurLinear,
  postCircleCrop,
  preCurlVar,
  preGaussianVar,
  postAxisSymmetryWf,
  postBWraps2,
  postCrop,
  postCurl,
  postHeatVar,
  postMirrorWf,
  postPointSymmetryWf,
  blob,
  cliffordVar,
  circus,
  coneVar,
  conicVar,
  cornersVar,
  cos2_bsVar,
  cosh2_bsVar,
  cot2_bsVar,
  coth2_bsVar,
  cpowVar,
  cpow2Var,
  curlVar,
  dSphericalVar,
  dragonVar,
  fan2,
  fdiscVar,
  fibonacci2Var,
  floraVar,
  flowerVar,
  fluxVar,
  fourthVar,
  fresnelVar,
  funnelVar,
  gingerBreadVar,
  glynnSim1Var,
  glynnSim2Var,
  glynnSim3Var,
  gosperVar,
  grid,
  gridout2Var,
  gumowskiMiraVar,
  harmonographVar,
  henonVar,
  hexesVar,
  hexModulusVar,
  hilbertVar,
  hole2Var,
  holeVar,
  hopalongVar,
  hyperbolicEllipseVar,
  hypertile2Var,
  hypershiftVar,
  hypertileVar,
  intersectionVar,
  iconAttractorVar,
  invCircle,
  invCircle2,
  invEllipse,
  inversionVar,
  juliaCVar,
  juliaNVar,
  juliaOutsideVar,
  juliaScope,
  joukowskiVar,
  kaleidoscopeVar,
  kochVar,
  lazySensenVar,
  layeredSpiralVar,
  lazySusanVar,
  lissajousVar,
  linearTVar,
  lineVar,
  logApoVar,
  logTile2Var,
  loonie2Var,
  loqVar,
  loziVar,
  macMillanVar,
  maskVar,
  maurerRoseVar,
  mobiusVar,
  modulusVar,
  ngonVar,
  pdjVar,
  perspective,
  phoenixJuliaVar,
  pieVar,
  plusRecipVar,
  pixelFlowVar,
  popcorn2Var,
  powBlockVar,
  pressureWaveVar,
  projectiveVar,
  pTransformVar,
  perlinNoiseVar,
  radialBlurVar,
  rectanglesVar,
  rings2,
  rippleVar,
  roseVar,
  rsquaresVar,
  rational3Var,
  sattractorVar,
  scry2Var,
  seaShellVar,
  separationVar,
  sigmoidVar,
  sintrangeVar,
  sineBlurVar,
  shiftVar,
  shredradVar,
  shredlinVar,
  shreddedVar,
  sierCarpetVar,
  starBlurVar,
  sinusGridVar,
  sphericalNVar,
  spirographVar,
  splitVar,
  splitBrdrVar,
  spligonVar,
  splipticBSVar,
  splitsVar,
  squirrelVar,
  squishVar,
  squircularVar,
  swirl3Var,
  symBandG1,
  symBandG2,
  symBandG3,
  symBandG4,
  symBandG5,
  symBandG6,
  symBandG7,
  symNetG1,
  symNetG2,
  symNetG3,
  symNetG4,
  symNetG5,
  symNetG6,
  symNetG7,
  symNetG8,
  symNetG9,
  symNetG10,
  symNetG11,
  symNetG12,
  symNetG13,
  symNetG14,
  symNetG15,
  symNetG16,
  symNetG17,
  tradeVar,
  treeVar,
  triangleVar,
  truchet2Var,
  tunnelVar,
  vogelVar,
  waffleVar,
  wallPaperVar,
  waves2Var,
  waves3Var,
  waves4Var,
  wedgeJuliaVar,
  wedgeSphVar,
  wedgeVar,
  whorlVar,
  anamorphCylVar,
  asteriaVar,
  atanVar,
  atan2SpiralsVar,
  augerVar,
  barycentroidVar,
  bcollideVar,
  bent2Var,
  bipolar2Var,
  bipolarVar,
  bsplitVar,
  bwraps7Var,
  blockYVar,
  bmodVar,
  blurPixelizeVar,
  blurZoomVar,
  boarders2Var,
  boxfoldVar,
  bswirlVar,
  bTransformVar,
  bubble2Var,
  bulgeVar,
  butterflyFayVar,
  bwrandsVar,
  camouflageVar,
  cannabisCurveVar,
  cardioidVar,
  cellVar,
  cell2Var,
  chaosCubesVar,
  checksVar,
  chunkVar,
  circlesplitVar,
  circlize2Var,
  circlizeVar,
  circleLinearVar,
  circleRandVar,
  circular2Var,
  circularVar,
  collideoscopeVar,
  cropBoxVar,
  cropCrossVar,
  cropPolygonVar,
  cropRhombusVar,
  cropStarsVar,
  cropTriangleVar,
  crobVar,
  csc2_bsVar,
  csch2_bsVar,
  cscSquaredVar,
  csinVar,
  curveVar,
  cutApollonianVar,
  cutCircleDesignVar,
  cutFractalVar,
  devilWarpVar,
  disc2Var,
  disc3Var,
  eclipseVar,
  eModVar,
  eMotionVar,
  ePushVar,
  ejuliaVar,
  ellipticVar,
  elliptic2Var,
  epispiralVar,
  eRotateVar,
  eScaleVar,
  eSwirlVar,
  escherVar,
  exp2_bsVar,
  juliaQVar,
  kaplanVar,
  murl2Var,
  murlVar,
  nPolarVar,
  octagonVar,
  onion2Var,
  onionVar,
  oscilloscopeVar,
  oscilloscope2Var,
  ovoidVar,
  parabolaVar,
  pulseVar,
  q_odeVar,
  sTwinVar,
  stripfitVar,
  stripesVar,
  sunflowerVar,
  superShapeVar,
  targetVar,
  taurusVar,
  tileHlpVar,
  svenssonVar,
  synthVar,
  woggleVar,
  xheartVar,
  yinYangVar,
}
